module.exports = __webpack_public_path__ + "media/images/icons/v2/message-text-square-02-386f554f051e980d5f80d9b9884c1938.svg";